import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { StorageService } from 'src/app/services/common/storage';
import { AppState, selectAuthState } from 'src/app/store/app.states';
import { faBars } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-vendor-courses',
  templateUrl: './vendor-courses.component.html',
  styleUrls: ['./vendor-courses.component.scss']
})
export class VendorCoursesComponent implements OnInit {

  faBars = faBars;
  public state: any;
  isCollapsed = true;
  items = [
    { isCollapsed: true, title: "Revue Biblique", description: " Revue des bases doctrinales de la foi chrétienne.", level: "Niveau 1", courses: "11", picture: "../assets/img/courses/N1.png" },
    { isCollapsed: true, title: "Fondements de la foi", description: "Ce module porte sur l’étude de l’histoire du christianisme, l’histoire de l’Église et de la Bible ainsi que sur les principes d’interprétation des Écritures.", level: "Niveau 2", courses: "13", picture: "assets/img/courses/N2.png" },
    { isCollapsed: true, title: "Dimension Individuelle ", description: "Ce module vise la mise à disposition d’outils pour être un acteur de l’établissement du règne et du royaume de Dieu dans toutes les sphères de la société. Comment être le sel de la Terre et la lumière du monde", level: "Niveau 3", courses: "9", picture: "assets/img/courses/N3.png" },
    { isCollapsed: true, title: "Dimensions collective", description: "Dans ce module, il est question de comprendre quel est le regard de Dieu et le rôle de l’Église dans le monde aujourd’hui", level: "Niveau 4", courses: "5", picture: "assets/img/courses/N4.png" }];
  public isAuthenticated: any;
  constructor(public router: Router, public store: Store<AppState>, public localStorage: StorageService) { }

  ngOnInit(): void {
    this.store.select(selectAuthState).subscribe((state) => {
      this.state = state;
      this.localStorage.getItem('isAuthenticated').then(x => {
        this.isAuthenticated = x;
      });
    });
  }

  stepsDetail() {
    this.router.navigateByUrl("/modules");

  }
  // if (this.isAuthenticated) {
  //   this.router.navigateByUrl("/modules");
  // }
  // else {
  //   this.router.navigateByUrl("/registration");
  // }



}
